import React from 'react';
import ReactDOM from 'react-dom/client';
//React Router Dom
import { BrowserRouter } from 'react-router-dom';
// Bootstrap d'abord : on ne garde que la grille et les utilitaires, et notre
// couche de design (index.css + App.css) doit pouvoir le surcharger.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
